<template>
  <div class="all-employe" v-loading="loading">
    <div class="handle">
      <div class="left fl">
        <el-button type="primary" class="add" @click="createEmploye"
          >添加新员工</el-button
        >
        <el-button
          class="delete"
          @click="delEmployes"
          :disabled="selectedEmployes.length == 0"
          >批量删除</el-button
        >
        <!-- <el-button class="freeze">批量审核</el-button> -->
        <div class="divider"></div>
        <div class="select-time">
          <el-select
            v-model="inputValue"
            @change="employeTime"
            placeholder="请选择"
            class="handle-select"
            :class="{ 'select-radius': inputValue !== 'all' }"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <div v-if="inputValue !== 'all'">
            <el-date-picker
              v-model="time"
              type="daterange"
              unlink-panels
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="getEmployeList"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
            ></el-date-picker>
          </div>
        </div>
      </div>
      <div class="right fr">
        <el-input
          :placeholder="searchSelect"
          v-model="searchFilter"
          @keyup.enter.native="getEmployeList"
          class="input-with-select"
        >
          <el-select
            v-model="searchSelect"
            slot="prepend"
            placeholder="请选择"
            @change="filterSelect"
          >
            <el-option
              label="全文搜索"
              value="姓名/手机号/家庭住址"
            ></el-option>
            <el-option label="联系方式" value="请输入联系方式"></el-option>
            <el-option label="电子邮箱" value="请输入电子邮箱"></el-option>
            <el-option label="家庭住址" value="请输入家庭住址"></el-option>
            <el-option label="现居地址" value="请输入现居地址"></el-option>
            
          </el-select>
          <i
            class="el-icon-search el-input__icon input__suffix"
            slot="suffix"
            @click="getEmployeList"
          ></i>
        </el-input>
        <div @click="getEmployeList('refresh')">
          <svg-icon class="svg" icon-class="refresh-ico" />
        </div>
        <el-popover
          placement="top"
          title
          width="30"
          height="49"
          trigger="hover"
          content="设置"
        >
          <div slot="reference">
            <div @click="showFiltrate = true">
              <svg-icon class="svg" icon-class="filtrate-ico" />
            </div>
          </div>
        </el-popover>
        <!-- <div @click="derive">
          <svg-icon class="svg" icon-class="derive-ico" />
        </div> -->
      </div>
    </div>
    <div
      v-if="postSearch.length > 0 || positionSearch.length > 0"
      class="search-view"
    >
      当前已选条件：
      <ul>
        <li v-if="postSearch.length > 0">
          职务：
          <span
            v-for="(item, index) in postSearch"
            v-show="index < 6"
            :key="index"
            class="post-search"
            >{{ item }}</span
          >
          <span class="post-search" v-show="postSearch.length > 6">...</span>
          <div class="svg" @click="closeSearch('post')">
            <svg-icon class="svg" icon-class="close-ico"></svg-icon>
          </div>
        </li>
        <li v-if="positionSearch.length > 0">
          职级：
          <span
            v-for="(item, index) in positionSearch"
            v-show="index < 6"
            :key="index"
            class="position-search"
            >{{ item }}</span
          >
          <span class="post-search" v-show="positionSearch.length > 6"
            >...</span
          >
          <div class="svg" @click="closeSearch('position')">
            <svg-icon class="svg" icon-class="close-ico"></svg-icon>
          </div>
        </li>
      </ul>
      <div class="clean" @click="cleanSearch">
        <svg-icon class="svg" icon-class="clean-ico"></svg-icon>清空条件
      </div>
    </div>
    <main :style="employeHeight">
      <div class="left" :class="isFold ? 'is-fold-left' : 'not-fold-left'">
        <div class="head">
          <div class="search">
            <el-input
              class="input"
              v-model="orgSearch"
              placeholder="请输入公司、部门、小组名称"
            >
              <i
                class="el-icon-search el-input__icon input__suffix"
                slot="suffix"
                @click="searchOrgs()"
              ></i>
            </el-input>
          </div>
        </div>
        <div class="content">
          <el-tree
            ref="tree"
            :data="companyList"
            show-checkbox
            :check-on-click-node="true"
            @check="checkSerch"
            :props="{ children: 'children', isLeaf: 'isLeaf' }"
            node-key="id"
            class="tree-width"
            :expand-on-click-node="true"
            :load="loadTreeNodes"
            lazy
          >
            <span
              class="custom-tree-node"
              ref="treeChild"
              slot-scope="{ data }"
            >
              <el-tooltip
                class="item"
                effect="dark"
                :content="data.data.name"
                placement="top"
                :disabled='data.data.name.length<16'
              >
                <span>{{ data.data.name }}</span>
              </el-tooltip>
            </span>
          </el-tree>
        </div>
      </div>
      <div class="right" :class="isFold ? 'is-fold-right' : 'not-fold-right'">
        <div class="list-table">
          <el-table
            stripe
            :class="{
              'filter-table':
                query.type || checkOrgs.length !== 0 || Array.isArray(time),
            }"
            :data="employeList"
            ref="filterTable"
            @selection-change="handleSelectionChange"
            @filter-change="filterIds"
          >
            <el-table-column type="selection" width="50" />
            <!--控制是否可以选择 :selectable='checkboxInit' -->
            <el-table-column
              v-if="tableTitleKey.includes('姓名/工号')"
              label-class-name="tab-tit"
              label="姓名/工号"
              width="200"
              align="left"
            >
              <template slot-scope="scope">
                <div class="name-worknum">
                  <img
                    :src="scope.row.photoUrl ? scope.row.photoUrl : defaultHead"
                    class="head-img"
                  />
                  <div>
                    <span>
                      {{
                        scope.row.name ? scope.row.name : "匿名" | valLength(4)
                      }}
                      <span class="isLockout" v-if="scope.row.isLockout"
                        >(已冻结)</span
                      >
                    </span>
                    <br />
                    <span>{{
                      scope.row.emId ? scope.row.emId : "工号未分配"
                    }}</span>
                    <br />
                    <span class="quick-view" @click="quickView(scope.row)"
                      >快捷查看</span
                    >
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-if="tableTitleKey.includes('性别')"
              label-class-name="tab-tit"
              label="性别"
              min-width="50"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.sex | nullValue }}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-if="tableTitleKey.includes('联系电话')"
              label-class-name="tab-tit"
              label="联系电话"
              min-width="150"
              align="center"
            >
              <template slot-scope="scope">
                <span
                  >{{ scope.row.phoneNumber.substring(0, 3) }}****{{
                    scope.row.phoneNumber.substring(
                      scope.row.phoneNumber.length - 4
                    )
                  }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              v-if="tableTitleKey.includes('电子邮箱')"
              prop="email"
              label-class-name="tab-tit"
              label="电子邮箱"
              min-width="150"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.email | nullValue }}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-if="tableTitleKey.includes('部门')"
              label-class-name="tab-tit"
              label="部门"
              min-width="80"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.organizationUnit | nullValue }}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-if="tableTitleKey.includes('职务')"
              label-class-name="tab-tit tit-enable-click"
              label="职务"
              column-key="postIds"
              :filters="postFilters"
              :filter-multiple="true"
              min-width="120"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.post | nullValue }}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-if="tableTitleKey.includes('职级')"
              label-class-name="tab-tit tit-enable-click"
              label="职级"
              column-key="positionIds"
              :filters="positionFilters"
              :filter-multiple="true"
              min-width="120"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.position | nullValue }}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-if="
                tableTitleKey.includes('工龄') &&
                activeName != 'waiting-regular' &&
                activeName != 'waiting-employe' &&
                activeName != 'waiting-quit'
              "
              label-class-name="tab-tit"
              label="工龄"
              min-width="100"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.currentWorkingTime }}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-if="
                tableTitleKey.includes('累计工龄') &&
                activeName != 'waiting-regular' &&
                activeName != 'waiting-employe' &&
                activeName != 'waiting-quit'
              "
              label-class-name="tab-tit"
              label="累计工龄"
              min-width="100"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.cumulativeWorkingTime }}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-if="tableTitleKey.includes('家庭住址')"
              label-class-name="tab-tit"
              label="家庭住址"
              min-width="100"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.familyAddress | nullValue }}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-if="tableTitleKey.includes('现居地址')"
              label-class-name="tab-tit"
              label="现居地址"
              min-width="100"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.currentAddress | nullValue }}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-if="tableTitleKey.includes('状态')"
              label-class-name="tab-tit"
              label="状态"
              min-width="80"
              align="center"
            >
              <template slot-scope="scope">
                <div class="status">
                  <div>
                    <div>{{ scope.row.status | nullValue }}</div>
                    <div v-if="scope.row.changeType">
                      {{ scope.row.changeType }}
                    </div>
                    <div
                      class="quick-view"
                      v-if="scope.row.status == '入职驳回原因'"
                      @click="viewRejectionReason('入职驳回原因', scope.row)"
                    >
                      查看原因
                    </div>
                    <div
                      class="quick-view"
                      v-if="scope.row.status == '异动被驳回'"
                      @click="viewRejectionReason('异动驳回原因', scope.row)"
                    >
                      查看原因
                    </div>
                    <div
                      class="quick-view"
                      v-if="scope.row.changeType == '岗位调整'"
                      @click="viewRejectionReason('异动详细信息', scope.row)"
                    >
                      查看详情
                    </div>
                    <div
                      class="quick-view"
                      v-if="scope.row.changeType == '待离职'"
                      @click="viewRejectionReason('员工离职信息', scope.row)"
                    >
                      查看原因
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="150" fixed="right">
              <template slot-scope="scope">
                <div class="table-operation">
                  <el-button
                    @click.native.prevent="manageEmploye(scope.row.id, '管理')"
                    type="text"
                    >管理</el-button
                  >
                  <el-button
                    @click.native.prevent="checkEmploye(scope.row)"
                    type="text"
                    v-if="
                      !scope.row.isMainGrade &&
                      (activeName == 'waiting-employe' ||
                        activeName == 'change-audit' ||
                        activeName == 'waiting-quit' ||
                        activeName == 'waiting-regular')
                    "
                    >审核</el-button
                  >
                  <el-button
                    @click.native.prevent="switchAccountStatus(scope.row)"
                    type="text"
                    v-if="
                      activeName == 'regular-employe' ||
                      activeName == 'quit-employe' ||
                      activeName == 'all-employe'
                    "
                    >{{ scope.row.isLockout ? "解冻" : "冻结" }}</el-button
                  >
                  <!-- <el-button
                    @click.native.prevent="delEmploye(scope.row)"
                    type="text"
                    class="del-btn"
                    v-if="!scope.row.isMainGrade"
                  >删除</el-button> -->
                  <el-popover placement="bottom" trigger="click">
                    <el-button
                      @click.native.prevent="delEmploye(scope.row)"
                      type="text"
                      class="del-btn"
                      >删除</el-button
                    >
                    <el-button
                      slot="reference"
                      type="text"
                      class="more-btn"
                      v-if="!scope.row.isMainGrade"
                      >更多</el-button
                    >
                  </el-popover>
                </div>
              </template>
            </el-table-column>
            <template slot="empty">
              <div class="loading-box" v-if="isLoading">
                <img
                  src="../../../../assets/image/loading.png"
                  alt="loading"
                  class="loading-ico"
                />
                数据加载中...
              </div>
              <div class="empty-box" v-if="!isLoading && !employeList.length">
                列表为空
              </div>
            </template>
          </el-table>
        </div>
        <el-pagination
          class="pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageIndex"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="query.maxResultCount"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
        <img
          src="../../../../assets/image/fold.png"
          alt="fold"
          class="fold-img"
          @click="isFold = !isFold"
        />
      </div>
    </main>
    <el-dialog
      title="自定义列表字段 "
      :visible.sync="showFiltrate"
      width="800px"
      :before-close="handleClose"
      custom-class="filter-dialog"
    >
      <el-transfer
        filterable
        :filter-method="filterMethod"
        :titles="['请选择你想显示的列表字段', '已选择字段']"
        filter-placeholder="请输入字段名称"
        v-model="tableTitleKey"
        :data="tabTitData"
      ></el-transfer>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showFiltrate = false">取 消</el-button>
        <el-button type="primary" @click="showFiltrate = false">确定</el-button>
      </div>
    </el-dialog>
    <el-drawer
      :title="employe.name ? employe.name : '匿名'"
      :with-header="false"
      :visible.sync="isDrawerShow"
      direction="rtl"
    >
      <div class="drawer-title">
        {{ employe.name ? employe.name : "匿名" }}
        <span @click="isDrawerShow = false">
          <svg-icon icon-class="close-ico" />
        </span>
      </div>
      <el-form label-position="left" label-width="6rem">
        <div class="basic-item">
          <div class="basic-item-title basic-title-edit">
            基本信息
            <div class="basic-edit" @click="manageEmploye(employe.id, '修改')">
              修改
            </div>
          </div>
          <div class="basic-item-main">
            <div class="main-item">
              <el-form-item label="头像" class="auto-height">
                <div class="work-card">
                  <div class="work-card-item work-card-print">
                    <img
                      :src="employe.photoUrl ? employe.photoUrl : defaultHead"
                      alt="workCard"
                      class="work-card-img"
                      id="print"
                    />
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="性别">{{
                employe.sex | nullValue
              }}</el-form-item>
              <el-form-item label="身份证号">
                <div class="encrypt-number">
                  <span v-if="isShow.identityCard">{{
                    employe.identityCard
                  }}</span>
                  <span v-else-if="employe.identityCard"
                    >{{ employe.identityCard[0] }}****************{{
                      employe.identityCard[employe.identityCard.length - 1]
                    }}</span
                  >
                  <div
                    class="show-svg"
                    @click="authLook('identityCard')"
                    v-if="employe.identityCard"
                  >
                    <svg-icon icon-class="hidden" v-if="isShow.identityCard" />
                    <svg-icon icon-class="show" v-else />
                  </div>
                  <span v-else>--</span>
                </div>
              </el-form-item>
              <el-form-item label="出生日期">{{
                employe.birthday ? employe.birthday.split("T")[0] : "--"
              }}</el-form-item>
              <el-form-item label="籍贯">{{
                employe.native | nullValue
              }}</el-form-item>
              <el-form-item label="招聘渠道">{{
                employe.recruitWay | nullValue
              }}</el-form-item>
              <el-form-item label="家庭住址">{{
                employe.familyAddress | nullValue
              }}</el-form-item>
              <el-form-item label="现居住地">{{
                employe.residence | nullValue
              }}</el-form-item>
              <el-form-item label="婚姻状况">{{
                employe.marriageStatus | nullValue
              }}</el-form-item>
            </div>
            <div class="main-item basic-item-right">
              <el-form-item label="民族">{{
                employe.nation | nullValue
              }}</el-form-item>
              <el-form-item label="政治面貌">{{
                employe.political | nullValue
              }}</el-form-item>
              <el-form-item label="带训师">{{
                employe.isTrainingTeacher ? employe.trainingTeacherGrade : "否"
              }}</el-form-item>
              <el-form-item label="手机号">
                <div class="encrypt-number phone-number">
                  <span v-if="isShow.phoneNumber">{{
                    employe.phoneNumber
                  }}</span>
                  <span v-else-if="employe.phoneNumber"
                    >{{ employe.phoneNumber.substring(0, 3) }}****{{
                      employe.phoneNumber.substring(
                        employe.phoneNumber.length - 4
                      )
                    }}</span
                  >
                  <div
                    class="show-svg"
                    @click="authLook('phoneNumber')"
                    v-if="employe.phoneNumber"
                  >
                    <svg-icon icon-class="hidden" v-if="isShow.phoneNumber" />
                    <svg-icon icon-class="show" v-else />
                  </div>
                  <span v-else>--</span>
                </div>
              </el-form-item>
              <el-form-item label="微信号">{{
                employe.wechat | nullValue
              }}</el-form-item>
              <el-form-item label="QQ账号">{{
                employe.qq | nullValue
              }}</el-form-item>
              <el-form-item label="邮箱">{{
                employe.email | nullValue
              }}</el-form-item>
              <el-form-item label="紧急联系人">{{
                employe.contactName | nullValue
              }}</el-form-item>
              <el-form-item label="紧急联系电话">
                <div class="encrypt-number phone-number">
                  <span v-if="isShow.emergencyPhoneNumber">{{
                    employe.contactPhoneNumber
                  }}</span>
                  <span v-else-if="employe.contactPhoneNumber"
                    >{{ employe.contactPhoneNumber.substring(0, 3) }}****{{
                      employe.contactPhoneNumber.substring(
                        employe.contactPhoneNumber.length - 4
                      )
                    }}</span
                  >
                  <div
                    class="show-svg"
                    v-if="employe.contactPhoneNumber"
                    @click="authLook('contactPhoneNumber')"
                  >
                    <svg-icon
                      icon-class="hidden"
                      v-if="isShow.emergencyPhoneNumber"
                    />
                    <svg-icon icon-class="show" v-else />
                  </div>
                  <span v-else>--</span>
                </div>
              </el-form-item>
              <el-form-item label="与联系人关系">{{
                employe.contactRelationship | nullValue
              }}</el-form-item>
              <el-form-item label="账号锁定">
                <div v-if="employe.isLockout" class="lockout-box is-lockout">
                  <svg-icon icon-class="status-close" />已锁定
                </div>
                <div v-else class="lockout-box not-lockout">
                  <svg-icon icon-class="success" />正常
                </div>
              </el-form-item>
            </div>
          </div>
        </div>

        <div class="basic-item">
          <div class="basic-item-title">员工状态</div>
          <div class="basic-item-main">
            <div class="main-item">
              <el-form-item label="状态">{{
                employe.status | nullValue
              }}</el-form-item>
              <el-form-item
                :label="employe.status + '限'"
                v-if="employe.status == '试用期' || employe.status == '复岗期'"
                >{{ employe.tryWorkDays | filterTryDays }}</el-form-item
              >
              <el-form-item label="转正考试">{{
                employe.hasPassedRegularWorkTest ? "通过" : "未通过"
              }}</el-form-item>
              <el-form-item
                label="转正日期"
                v-if="
                  employe.status == '正式员工' || employe.status == '已离职'
                "
                >{{ employe.regularWorkTime | getTime }}</el-form-item
              >
              <el-form-item label="计划转正日期" v-else>{{
                employe.regularWorkTime | getTime
              }}</el-form-item>
            </div>
            <div class="main-item basic-item-right">
              <el-form-item label="入职日期">{{
                employe.workTime | getTime
              }}</el-form-item>
              <el-form-item label="工龄">{{
                employe.currentWorkingTime
              }}</el-form-item>
              <div v-if="employe.status == '已离职'">
                <el-form-item label="离职时间">{{
                  employe.firedTime | getTime
                }}</el-form-item>
                <el-form-item label="离职原因">{{
                  employe.firedReason | nullValue
                }}</el-form-item>
              </div>
            </div>
          </div>
        </div>
        <div class="basic-item" v-if="jobList && jobList.length > 0">
          <div class="basic-item-title">岗位信息</div>
          <el-table :data="jobList" style="width: 100%" header-align="center">
            <el-table-column prop="grade" label="职务/职级" width="250">
              <template slot-scope="scope">
                <div class="grade-box">
                  {{ scope.row.post.name }}/{{ scope.row.position.name }}
                  <div class="grade-main" v-if="scope.row.isMajor">主岗</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="organizationUnit" label="部门">
              <template slot-scope="scope">{{
                scope.row.organizationUnit.name
              }}</template>
            </el-table-column>
            <el-table-column prop="organizationUnit" label="生效时间">
              <template slot-scope="scope">{{
                scope.row.effectiveTime | filterSpaceTime
              }}</template>
            </el-table-column>
            <el-table-column prop="more" label="备注" align="center">
              <template slot-scope="scope">{{
                scope.row.more | nullValue
              }}</template>
            </el-table-column>
          </el-table>
        </div>
        <div class="basic-item">
          <div class="basic-item-title">社保信息</div>
          <div class="basic-item-main">
            <div class="main-item">
              <el-form-item label="工资卡号">{{
                employe.cardNumber | nullValue
              }}</el-form-item>
              <el-form-item label="银行">{{
                employe.cardBank | nullValue
              }}</el-form-item>
              <el-form-item label="支行">{{
                employe.cardBankName | nullValue
              }}</el-form-item>
            </div>
            <div class="main-item basic-item-right">
              <el-form-item label="所属城市">{{
                employe.cardCity | nullValue
              }}</el-form-item>
              <el-form-item label="是否参保">{{
                employe.hasJoinedSocialInsurance ? "是" : "否"
              }}</el-form-item>
              <!-- <el-form-item label="社保方案">{{employe.scheme}}</el-form-item>
              <el-form-item label="社保账号">{{employe.number}}</el-form-item>-->
            </div>
          </div>
        </div>
        <div class="basic-item">
          <div class="basic-item-title">教育信息</div>
          <div class="basic-item-main">
            <div class="main-item">
              <el-form-item label="学历">{{
                employe.educationType | nullValue
              }}</el-form-item>
              <el-form-item label="专业">{{
                employe.profession | nullValue
              }}</el-form-item>
            </div>
            <div class="main-item basic-item-right">
              <el-form-item label="毕业院校">{{
                employe.college | nullValue
              }}</el-form-item>
              <el-form-item label="毕业时间">{{
                employe.graduationTime | filterTime
              }}</el-form-item>
            </div>
          </div>
        </div>
      </el-form>
    </el-drawer>
    <el-dialog
      :title="dialogTit"
      :visible.sync="dialogVisible"
      width="550px"
      :before-close="handleClose"
      custom-class="examine-dialog"
    >
      <span v-if="dialogTit == '员工入职审核'">是否通过入职审核？</span>
      <span
        slot="footer"
        class="dialog-footer"
        v-if="dialogTit == '员工入职审核'"
      >
        <el-button @click="rejectExamine('驳回原因')">驳回</el-button>
        <el-button type="primary" @click="pass">通过</el-button>
      </span>
      <span v-if="dialogTit == '员工转正审核'">是否通过转正审核？</span>
      <span
        slot="footer"
        class="dialog-footer"
        v-if="dialogTit == '员工转正审核'"
      >
        <el-button @click="rejectExamine('驳回原因')">驳回</el-button>
        <el-button type="primary" @click="pass">通过</el-button>
      </span>

      <span v-if="dialogTit == '异动详细信息'">
        <el-form label-width="4rem" label-position="left">
          <el-form-item label="原岗位"
            >{{ changeRecordInfo.oldPost }}-{{
              changeRecordInfo.oldPosition
            }}-{{ changeRecordInfo.oldOrganizationUnit }}</el-form-item
          >
          <el-form-item label="调整为" class="no-margin-bototm"
            >{{ changeRecordInfo.post }}-{{ changeRecordInfo.position }}-{{
              changeRecordInfo.organizationUnit
            }}</el-form-item
          >
        </el-form>
      </span>
      <span
        slot="footer"
        class="dialog-footer"
        v-if="dialogTit == '异动详细信息' || dialogTit == '入职驳回原因'"
      >
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确认</el-button
        >
      </span>

      <span v-if="dialogTit == '员工岗位异动审核'">
        <el-form label-width="4rem" label-position="left">
          <el-form-item label="原岗位"
            >{{ changeRecordInfo.oldPost }}-{{
              changeRecordInfo.oldPosition
            }}-{{ changeRecordInfo.oldOrganizationUnit }}</el-form-item
          >
          <el-form-item label="调整为" class="no-margin-bototm"
            >{{ changeRecordInfo.post }}-{{ changeRecordInfo.position }}-{{
              changeRecordInfo.organizationUnit
            }}</el-form-item
          >
        </el-form>
      </span>
      <span
        slot="footer"
        class="dialog-footer"
        v-if="dialogTit == '员工岗位异动审核'"
      >
        <el-button @click="rejectExamine('驳回原因')">驳回</el-button>
        <el-button type="primary" @click="pass">通过</el-button>
      </span>

      <span v-if="dialogTit == '员工离职审核'">是否设置为离职员工？</span>
      <span
        slot="footer"
        class="dialog-footer"
        v-if="dialogTit == '员工离职审核'"
      >
        <el-button @click="rejectExamine('驳回原因')">驳回</el-button>
        <el-button type="primary" @click="pass">通过</el-button>
      </span>

      <span v-if="dialogTit == '驳回原因'">
        <el-form label-width="4rem" label-position="left" :rules="rejectRules">
          <el-form-item label="驳回原因" class="auto-height" prop="reason">
            <el-input
              type="textarea"
              v-model="reason"
              maxlength="500"
              show-word-limit
              resize="none"
            ></el-input>
          </el-form-item>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer" v-if="dialogTit == '驳回原因'">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="refuse">确认</el-button>
      </span>

      <!-- <span v-if="dialogTit=='驳回原因'||dialogTit=='入职驳回原因'">{{reason}}</span>
      <span slot="footer" class="dialog-footer" v-if="dialogTit=='异动驳回原因'||dialogTit=='入职驳回原因'">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确认</el-button>
      </span>-->
    </el-dialog>
    <!-- 解冻/冻结状态修改 -->
    <el-dialog
      title="账户冻结"
      :visible.sync="isLockShow"
      width="550px"
      custom-class="employe-dialog lock-dialog"
      @close="handleClose('lockForm')"
    >
      <el-form
        :model="lockForm"
        label-position="left"
        label-width="4rem"
        ref="lockForm"
      >
        <el-form-item label="冻结原因" prop="reason" class="auto-height">
          <el-input
            type="textarea"
            v-model="lockForm.more"
            maxlength="60"
            show-word-limit
            resize="none"
            :placeholder="'请填写账户冻结原因'"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-tip">*账户一旦冻结，将不能登录使用</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isLockShow = false">取消</el-button>
        <el-button type="primary" @click="submitLock">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { debounce } from "@/utils/debounce";
import { getOrgAllTree, getOrgTree } from "@/http/api/organization";
import {
  getUsers,
  getUserOus,
  getUserPositions,
  delUser,
  delUserList,
  getUserJobs,
  userLockout,
  changeRecordsReview,
  getChangeRecord,
} from "@/http/api/employe";
import { deepCopy } from "@/utils/deepCopy";
import { getPostAllTree } from "@/http/api/position";

export default {
  props: ["employeHeight", "activeName"],
  watch: {
    activeName: {
      handler(value) {
        //console.log(value);
        if (value == "all-employe") {
          this.query.status = "";
          this.query.changeType = "";
          this.query.isWorkingUser = "";
          this.query.isLockout = "";
        } else if (value == "waiting-employe") {
          this.query.changeType = "Joining";
          this.query.isWorkingUser = "";
          this.query.isLockout = "";
        } else if (value == "waiting-regular") {
          this.query.changeType = "Regular";
          this.query.isWorkingUser = "";
          this.query.isLockout = "";
        } else if (value == "waiting-quit") {
          this.query.changeType = "Firing";
          this.query.isWorkingUser = "";
          this.query.isLockout = "";
        } else if (value == "change-audit") {
          this.query.changeType = "JobChange";
          this.query.isWorkingUser = "";
          this.query.isLockout = "";
        } else if (value == "regular-employe") {
          this.query.changeType = "";
          this.query.isWorkingUser = true;
          this.query.isLockout = "";
        } else if (value == "regular-isLockout-employe") {
          this.query.changeType = "";
          this.query.isWorkingUser = true;
          this.query.isLockout = true;
        } else if (value == "quit-employe") {
          this.query.changeType = "";
          this.query.isWorkingUser = false;
          this.query.isLockout = "";
        }

        this.getEmployeList();
      },
    },
  },
  data() {
    const generateData = (_) => {
      const data = [];
      const tabTits = [
        "姓名/工号",
        "性别",
        "联系电话",
        "部门",
        "职务",
        "职级",
        "工龄",
        "累计工龄",
        "状态",
        "电子邮箱",
        "家庭住址",
        "现居地址",
      ];
      const pinyin = [
        "xingming",
        "xingbie",
        "lianxidianhua",
        "bumen",
        "zhiwu",
        "zhiji",
        "gongling",
        "leijigongling",
        "zhuangtai",
        "dianziyouxiang",
        "jiatingzhuzhi",
        "xianjudizhi",
      ];
      tabTits.forEach((tabTit, index) => {
        data.push({
          label: tabTit,
          key: tabTit,
          pinyin: pinyin[index],
        });
      });
      return data;
    };
    return {
      loading: false,
      employe: {}, // 员工对象
      isShow: {
        identityCard: false,
        phoneNumber: false,
        emergencyPhoneNumber: false,
      }, // 显示加密字段
      defaultHead: require("../../../../assets/image/default-head.png"),
      tabTitData: generateData(),
      dialogVisible: false,
      tableTitleKey: [
        "姓名/工号",
        "性别",
        "联系电话",
        "部门",
        "职务",
        "职级",
        "工龄",
        "累计工龄",
        "状态",
      ],
      tableHeight: 0,
      isFold: false,
      isDrawerShow: false,
      lockForm: {
        more: "",
      },
      postFilters: [],
      positionFilters: [],
      positionSearch: [],
      postSearch: [],
      inputValue: "all",
      searchFilter: "",
      searchSelect: "姓名/手机号/家庭住址",
      time: null,
      orgSearch: "",
      companyList: [],
      org: "",
      employeList: [],
      jobList: [],
      showFiltrate: false,
      isLoading: true,
      checkOrgs: [],
      isLockShow: false,
      isLookPhoneAuth: false,
      isLookIdCardAuth: false,
      selectedEmployes: [],
      total: 0,
      reason: "",
      changeRecordInfo: {},
      query: {
        condition: "",
        filter: "",
        status: "",
        changeType: "",
        changeReviewStatus: "",
        timeCondition: "",
        isLockout: "",
        startTime: "",
        endTime: "",
        postIds: [],
        positionIds: [],
        maxResultCount: 30,
        skipCount: 0,
        organizationUnitIds: [],
        isWorkingUser: null,
        Sorting: "creationTime desc",
      },
      pageIndex: 1,
      dialogTit: "员工入职审核",
      options: [
        {
          value: "all",
          label: "全部时间",
        },
        {
          value: "WorkTime",
          label: "入职时间",
        },
        {
          value: "FiredTime",
          label: "离职时间",
        },
        {
          value: "RegularWorkTime",
          label: "转正时间",
        },
      ],
      userTypeFilters: [
        { text: "全部类型", value: "UserAdmin" },
        { text: "网站用户", value: "User" },
        { text: "后台用户", value: "Admin" },
      ],
      permissions: this.$store.getters.permissions,
      rejectRules: {
        reason: [
          { required: true, message: "请输入驳回原因", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.$watch(
      "orgSearch",
      debounce((val) => {
        this.searchOrgs();
      }, 200)
    );
    this.$watch(
      "searchFilter",
      debounce((val) => {
        if (!val) {
          this.getEmployeList();
        }
      }, 200)
    );
    this.isLookPhoneAuth = this.permissions[
      "RocketIdentity.Users.LookPhoneNumber"
    ];
    this.isLookIdCardAuth = this.permissions["RocketIdentity.Users.LookIdCard"];
  },
  mounted() {
    // //console.log("穿梭框的格式化数据", this.tabTitData);
    //console.log(this.permissions, "用户权限");
    this.searchOrgs();
    this.getEmployeList();
    this.getPosts();
  },
  methods: {
    authLook(v) {
      let msg = v == "identityCard" ? "身份证号" : "联系电话",
        auth =
          v == "identityCard" ? this.isLookIdCardAuth : this.isLookPhoneAuth;
      if (auth) {
        this.isShow[v] = !this.isShow[v];
      } else {
        this.$message.warning({
          message: `您暂无查看${msg}权限`,
          showClose: true,
        });
      }
    },
    //驳回审核
    refuse() {
      changeRecordsReview(this.employeInfo.changeRecordId, {
        reviewStatus: "refuse",
        refusedReason: this.reason,
      }).then((res) => {
        if (res) {
          this.$message.success({ message: "已驳回审核", showClose: true });
        }
        this.getEmployeList();
        this.dialogVisible = false;
      });
    },
    //通过审核
    pass() {
      changeRecordsReview(this.employeInfo.changeRecordId, {
        reviewStatus: "success",
      }).then((res) => {
        //console.log(res, "通过审核");
        if (res) {
          this.$message.success({ message: "审核通过", showClose: true });
        }
        this.getEmployeList();
        this.dialogVisible = false;
      });
    },
    // 切换员工账号状态
    switchAccountStatus(row) {
      this.employeInfo = row;
      if (this.permissions["RocketIdentity.Users.Lockout"]) {
        if (!this.employeInfo.isLockout) {
          this.isLockShow = true;
        } else {
          this.$confirm(
            `账户解冻后将恢复正常使用，是否继续操作？`,
            "账户解冻",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
            }
          )
            .then(() => {
              this.submitLock();
            })
            .catch(() => {
              //console.log("已取消");
            });
        }
      } else {
        let text;
        if (!this.employeInfo.isLockout) {
          text = "冻结";
        } else {
          text = "解冻";
        }
        this.$message.warning({
          message: `您暂无${text}员工账户权限`,
          showClose: true,
        });
      }
    },
    // 提交员工账号状态
    submitLock() {
      let query = {
        isLockout: !this.employeInfo.isLockout,
        lockoutReason: this.lockForm.more,
        concurrencyStamp: this.employeInfo.concurrencyStamp,
      };
      userLockout(this.employeInfo.id, query)
        .then((res) => {
          //console.log(res, 888999);
          let msg = this.employeInfo.isLockout ? "解冻成功" : "冻结成功";
          if (res) {
            this.$message.success({ message: msg, showClose: true });
          }
          this.getEmployeList();
        })
        .catch((err) => {});
      this.isLockShow = false;
    },
    // 搜索前置条件
    filterSelect(val) {
      //console.log(val, 1212);
      if (val == "请输入姓名前缀") {
        this.query.condition = "Name";
      } else if (val == "请输入联系方式") {
        this.query.condition = "PhoneNumber";
      } else if (val == "请输入家庭住址") {
        this.query.condition = "FamilyAddress";
      } else if (val == "请输入电子邮箱") {
        this.query.condition = "Email";
      } else if (val == "请输入现居地址") {
        this.query.condition = "CurrentAddress";
      } else if (val == "姓名/手机号/家庭住址") {
        this.query.condition = "";
      }
    },

    // 获取选择项
    handleSelectionChange(val) {
      this.selectedEmployes = val.map((item) => {
        return item.id;
      });
    },
    // 批量删除员工
    delEmployes() {
      if (this.permissions["RocketIdentity.Users.Delete"]) {
        this.$confirm(`此操作将删除员工信息, 请谨慎操作?`, "温馨提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        })
          .then(() => {
            let data = "";
            this.selectedEmployes.forEach((element) => {
              data = `ids=${element}&${data}`;
            });
            delUserList(data).then((res) => {
              if (res) {
                this.$message.success({
                  message: "员工删除成功",
                  showClose: true,
                });
              }
              this.getEmployeList();
            });
          })
          .catch(() => {
            //console.log("已取消");
          });
      } else {
        this.$message.warning({
          message: "您暂无删除员工权限",
          showClose: true,
        });
      }
    },
    // 删除员工
    delEmploye(row) {
      if (this.permissions["RocketIdentity.Users.Delete"]) {
        this.$confirm(`此操作将永久删除${row.name}, 是否继续?`, "温馨提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        })
          .then(() => {
            //console.log("delete");
            delUser(row.id).then((res) => {
              if (res) {
                this.$message.success({
                  message: "员工删除成功",
                  showClose: true,
                });
              }
              this.getEmployeList();
            });
          })
          .catch(() => {
            //console.log("已取消");
          });
      } else {
        this.$message.warning({
          message: "您暂无删除员工权限",
          showClose: true,
        });
      }
    },
    filterIds(val) {
      //console.log(val);
      if (
        val.positionIds &&
        val.positionIds !== null &&
        val.positionIds !== "" &&
        val.positionIds !== "undefined"
      ) {
        this.query.positionIds = [];
        this.positionSearch = [];
        val.positionIds.map((positionId) => {
          this.query.positionIds.push(positionId.split("/")[0]);
          this.positionSearch.push(positionId.split("/")[1]);
        });
        //console.log(this.query.postIds, 111111111111);
      } else if (
        val.postIds &&
        val.postIds !== null &&
        val.postIds !== "" &&
        val.postIds !== "undefined"
      ) {
        this.query.postIds = [];
        this.postSearch = [];
        val.postIds.map((postId) => {
          this.query.postIds.push(postId.split("/")[0]);
          this.postSearch.push(postId.split("/")[1]);
        });
        //console.log(this.query.postIds, 22222222222);
      }
      this.getEmployeList();
    },
    // 获取职务列表
    getPosts() {
      getPostAllTree().then((res) => {
        let arr = res.result.items;
        res.result.items.map((el) => {
          this.postFilters.push({
            text: el.data.name,
            value: `${el.data.id}/${el.data.name}`,
          });
          el.children.map((item) => {
            this.positionFilters.push({
              text: item.data.name,
              value: `${item.data.id}/${item.data.name}`,
            });
          });
        });
        //console.log(this.postFilters, this.positionFilters, "this.postFilters");
      });
      this.loading = false;
    },
    // 获取用户所属组织
    getOus(id) {
      getUserOus(id).then((res) => {
        this.orgs = res.result.items;
        this.isDrawerShow = true;
        //console.log(this.orgs, "this.orgs");
        this.posts.map((el, index) => {
          this.employe.job.push({});
        });
      });
      this.loading = false;
    },
    // 获取用户所属职级
    getPositions(id) {
      getUserPositions(id)
        .then((res) => {
          this.posts = res.result.items;
          //console.log(this.posts, "this.posts");
          if (this.posts.length) {
            this.getOus(id);
          } else {
            this.loading = false;
            this.isDrawerShow = true;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    getUserJobList(id) {
      getUserJobs(id)
        .then((res) => {
          //console.log(res, "resresres");
          if (res.result.items.length > 0) {
            this.jobList = res.result.items;
            let index = this.jobList.findIndex((el) => {
              return el.isMajor == true;
            });
            this.jobList.unshift(this.jobList.splice(index, 1)[0]);
          }
          //
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    checkEmploye(row) {
      this.employeInfo = row;
      if (row.changeType == "待入职") {
        this.dialogTit = "员工入职审核";
      } else if (row.changeType == "待转正") {
        this.dialogTit = "员工转正审核";
      } else if (row.changeType == "岗位调整") {
        this.dialogTit = "员工岗位异动审核";
      } else if (row.changeType == "待离职") {
        this.dialogTit = "员工离职审核";
      }
      if (this.permissions["RocketIdentity.Users.JobChangeReview"]) {
        this.dialogVisible = true;
        if (row.changeType == "岗位调整") {
          getChangeRecord(row.changeRecordId).then((res) => {
            //console.log(res, "获取的res");
            this.changeRecordInfo = res.result;
            this.dialogVisible = true;
          });
        }
      } else {
        this.$message.warning({
          message: `您暂无${this.dialogTit}权限`,
          showClose: true,
        });
      }
    },
    rejectExamine(text) {
      this.dialogTit = text;
    },
    viewRejectionReason(text, row) {
      this.dialogTit = text;
      if (text == "员工离职信息") {
        getChangeRecord(row.changeRecordId).then((res) => {
          //console.log(res, "获取的res");
          this.$confirm(res.result.description, "员工离职信息", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
          })
            .then(() => {})
            .catch(() => {});
        });
      } else if (text == "异动详细信息") {
        getChangeRecord(row.changeRecordId).then((res) => {
          this.changeRecordInfo = res.result;
          this.dialogVisible = true;
        });
      }
    },
    // 管理员工
    manageEmploye(id, v) {
      if (this.permissions["RocketIdentity.Users.Update"]) {
        this.$router.push("/channel/employe/management/" + id);
      } else {
        this.$message.warning({
          message: `您暂无${v}员工权限`,
          showClose: true,
        });
      }
    },
    // 快捷查看
    quickView(row) {
      this.employe = row;
      this.isDrawerShow = true;
      this.getUserJobList(row.id);
    },
    // 点击组织加载
    loadTreeNodes(val, resolve) {
      var node = val.data.data;
      if (node) {
        let query = {
          parentId: node.id,
          loadMode: 2,
          maxResultCount:1000
        };
        getOrgTree(query).then((res) => {
          resolve(res.result.items);
        });
      }
    },
    // 选择时间搜索
    employeTime(val) {
      //console.log("select", val);
      this.query.timeCondition = val;
      if (val === "all") {
        this.time = null;
        this.getEmployeList();
      } else {
      }
    },
    // 重置搜索
    closeSearch(val, data) {
      if (val === "type") {
        this.$refs.filter.columnConfig.filteredValue = [];
        this.query.type = "";
      }
      if (val === "org") {
        this.checkOrgs = [];
        this.$refs.tree.setCheckedKeys([]);
      }
      if (val === "time") {
        this.inputValue = "all";
        this.time = null;
      }
      if (val === "post") {
        this.postSearch = [];
        this.query.postIds = [];
        this.$refs.filterTable.clearFilter("postIds");
      }
      if (val === "position") {
        this.positionSearch = [];
        this.query.positionIds = [];
        this.$refs.filterTable.clearFilter("positionIds");
      }
      this.getEmployeList();
    },
    cleanSearch() {
      // this.$refs.filter.columnConfig.filteredValue = [];
      this.$refs.tree.setCheckedKeys([]);
      this.query.type = "";
      this.checkOrgs = [];
      this.query.startTime = "";
      this.query.endTime = "";
      this.inputValue = "all";
      this.time = "";
      this.postSearch = [];
      this.query.postIds = [];
      this.$refs.filterTable.clearFilter("postIds");
      this.positionSearch = [];
      this.query.positionIds = [];
      this.$refs.filterTable.clearFilter("positionIds");
      this.getEmployeList();
    },
    derive() {
      //console.log("导出");
    },
    handleSizeChange(val) {
      //console.log("更改的页面数量", val);
      this.query.maxResultCount = val;
      this.getEmployeList();
    },
    handleCurrentChange(val) {
      //console.log("跳转的指定页", val);
      this.pageIndex = val;
      this.getEmployeList();
    },
    // handleFilterChange(filters) {
    //   let key = Object.keys(filters)[0];
    //   if (key == "postIds" ) {
    //     this.query[key] = filters[key];
    //   } else {
    //     this.query[key] = filters[key][0];
    //   }
    //   //console.log("筛选的内容", filters);
    //   this.getEmployeList();
    // },
    filterMethod(query, item) {
      return item.pinyin.indexOf(query) > -1 || item.label.indexOf(query) > -1;
    },
    handleClose() {
      this.showFiltrate = false;
      this.dialogVisible = false;
      this.isLockShow = false;
      //console.log("获取的筛选数据", this.tableTitleKey);
    },
    checkSerch(data, checked, val) {
      this.checkOrgs = [];
      checked.checkedNodes.forEach((item) => {
        this.checkOrgs.push({ id: item.data.id, name: item.data.name });
      });
      this.getEmployeList();
    },
    // 搜索组织
    searchOrgs() {
      if (this.orgSearch) {
        let query = {
          loadMode: 2,
          filter: this.orgSearch,
        };
        getOrgTree(query).then((res) => {
          this.companyList = res.result.items;
          // //console.log("获取的组织机构", this.orgs);
        });
      } else {
        getOrgAllTree({ loadMode: 2 }).then((res) => {
          this.companyList = res.result.items;
          // //console.log("获取的组织机构", this.orgs);
        });
      }
    },
    // 获取员工列表
    getEmployeList(v) {
      this.isLoading = true;
      this.employeList = [];
      if (this.time != "" && this.time != null) {
        this.query.startTime = this.time[0];
        this.query.endTime = this.time[1];
      } else {
        this.query.startTime = "";
        this.query.endTime = "";
      }
      if (this.checkOrgs.length) {
        this.query.organizationUnitIds = [];
        this.checkOrgs.map((item) => {
          this.query.organizationUnitIds.push(item.id);
        });
      } else {
        this.query.organizationUnitIds = [];
      }
      if (this.searchFilter) {
        this.query.filter = this.searchFilter;
      } else {
        delete this.query.filter;
      }
      if (v == "refresh") {
        this.query = {
          status: "",
          changeType: "",
          changeReviewStatus: "",
          timeCondition: "",
          skipCount: 0,
          startTime: "",
          endTime: "",
          postIds: [],
          positionIds: [],
          maxResultCount: 30,
          organizationUnitIds: [],
          isWorkingUser: null,
        };
      } else {
        this.query.skipCount = (this.pageIndex - 1) * this.query.maxResultCount;
      }

      let query = "";
      for (var key in this.query) {
        if (this.query[key] !== null && this.query[key] !== "") {
          if (
            key == "postIds" ||
            key == "positionIds" ||
            key == "organizationUnitIds"
          ) {
            this.query[key].forEach((element) => {
              query = `${key}=${element}&${query}`;
            });
          } else {
            query = `${key}=${this.query[key]}&${query}`;
          }
        }
      }
      getUsers(query).then((res) => {
        this.total = res.result.totalCount;
        this.employeList = res.result.items;
        this.isLoading = false;
      });
    },
    createEmploye() {
      if (this.permissions["RocketIdentity.Users.Create"]) {
        this.$router.push("/channel/employe/create");
      } else {
        this.$message.warning({
          message: "您暂无添加新员工权限",
          showClose: true,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/mixin.scss";

.all-employe {
  padding: 20px;
  background-color: #fff;
}
.handle {
  width: 100%;
  height: 40px;
  min-width: 760px;
  .left,
  .right {
    display: flex;
    align-items: center;
  }

  .right {
    width: 450px;
    justify-content: space-between;
    ::v-deep .input-with-select {
      .el-select {
        width: 120px;
        .el-input__inner{
        width: 100%;
        box-sizing: border-box;
      }
      }
      .el-input__inner{
        width: 240px;
      }
    }
    .svg-icon {
      padding-left: 10px;
    }
  }

  .svg {
    width: 12px;
    height: 16px;
    cursor: pointer;
  }
}

.search-view {
  border-top: solid 1px #dddddd;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  ul {
    padding: 0;
    display: flex;
    align-items: center;
  }
  li {
    margin-right: 10px;
    padding: 5px 10px;
    background: #fff;
    font-size: 12px;
    color: #000000;
    border: 1px solid rgba(204, 204, 204, 1);
    div {
      position: relative;
      left: 2px;
      top: -2px;
      display: inline-block;
      width: 8px;
      height: 8px;
    }
    .position-search,
    .post-search {
      margin-right: 5px;
    }
    .svg {
      width: 8px;
      height: 8px;
      cursor: pointer;
    }
  }
  .clean {
    cursor: pointer;
    margin-left: 10px;
  }
}

main {
  border-top: 1px solid #f2f2f2;
  display: flex;
  border-radius: $--border-radius-base;
  width: 100%;
  background: #fff;
  // box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);

  .left {
    border-right: solid 1px #f2f2f2;

    .head {
      padding-right: 20px;
      .title {
        margin: 36px 0 31px;
        width: 90%;
        font-weight: bold;
        text-align: left;
        color: #000000;
        font-size: 14px;
      }
    }
    .search {
      margin-top: 27px;
      .input {
        width: 100%;
      }
    }
    .content {
      padding: 10px 20px 10px 0;
      overflow: auto;
    }
  }

  .is-fold-left {
    width: 0;

    .el-input {
      display: none;
    }
  }

  .not-fold-left {
    width: 320px;
    min-width: 320px;
  }

  .right {
    position: relative;

    .fold-img {
      position: absolute;
      top: 200px;
      left: -1px;
      transform: translateY(-50%);
      width: 15px;
      height: 60px;
      cursor: pointer;

      &:hover {
        filter: contrast(90%);
      }
    }

    .pagination {
      padding: 15px 10px;
    }

    .list-table {
      .name-worknum,
      .status {
        display: flex;
        line-height: 19px;
        .isLockout {
          color: #666;
        }
        .head-img {
          width: 60px;
          height: 60px;
          margin-right: 10px;
        }
      }
      .status {
        // @include flex(,center);
        justify-content: center;
      }

      ::v-deep .el-table {
        .quick-view {
          display: none;
          color: $--color-primary;
          cursor: pointer;
        }
        .el-table__row:hover {
          .quick-view {
            display: block;
          }
        }
        .el-table__body-wrapper {
          min-height: calc(100vh - 344px);
        }
      }

      ::v-deep .filter-table {
        .el-table__body-wrapper {
          min-height: calc(100vh - 398px);
        }
      }
    }
  }

  .is-fold-right {
    width: 100%;
  }

  .not-fold-right {
    width: calc(100% - 320px);
  }
}
.employe-remark {
  .el-form {
    margin-bottom: 15px;

    .el-textarea {
      width: 464px;
    }
  }

  .lock-info {
    margin-bottom: 20px;
  }
}
.el-dialog {
  .dialog-tip {
    // margin-top: -3px;
    margin-left: 4rem;
    width: 504px;

    font-size: 12px;
    font-weight: 400;
    line-height: 18px;

    color: #e6a23c;
  }

  .positive-date {
    margin-top: -5px;
  }

  .margin-bottom {
    margin-bottom: 22px;
  }
}
::v-deep .el-drawer {
  width: 700px !important;
  .basic-item {
    margin-bottom: 5px;

    .basic-item-title {
      margin-bottom: 20px;
      font-size: 14px;
      font-weight: bold;
      color: rgba(0, 0, 0, 1);
    }

    .basic-title-edit {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .basic-edit {
        font-size: 14px;
        font-weight: 400;
        color: $--color-primary;
        cursor: pointer;
      }
    }

    .basic-item-main {
      display: flex;

      .main-item {
        width: 50%;

        .el-select,
        .el-input {
          width: 330px;
        }

        .work-card {
          .work-card-item {
            margin-bottom: 15px;
            line-height: 0;

            .work-card-img {
              width: 143px;
              height: 148px;
            }
          }

          .work-card-print {
            margin-bottom: 0;
          }
        }

        .encrypt-number {
          display: flex;

          span {
            display: inline-block;
            width: 115px !important;
          }

          .show-svg {
            margin-left: 8px;

            .svg-icon {
              margin-top: -2px;
              cursor: pointer;
            }
          }
        }

        .phone-number {
          span {
            width: 75px;
          }
        }

        .job-num-box {
          display: flex;
          font-size: 12px;
          font-weight: 400;
          color: #000;
          vertical-align: middle;

          p {
            margin: 0;
          }

          .job-num-btn {
            margin-left: 10px;
            font-size: 12px;
            font-weight: 400;
            color: $--color-primary;
          }
        }

        .account-lock {
          display: inline-block;
          margin-right: 5px;
        }
      }

      .basic-item-right {
        padding-left: 50px;
      }

      .el-form-item {
        height: 30px;
        margin-bottom: 14px;
      }
    }

    .el-table {
      margin-bottom: 25px;
      .table-empty {
        color: $--color-primary;
        cursor: pointer;
      }
      .grade-box {
        @include flex(row, baseline);
        .grade-main {
          margin-left: 9px;
          border: 1px solid $--color-primary;
          padding: 0 5px;

          font-size: 12px;
          font-weight: 400;
          line-height: 18px;
          color: $--color-primary;
        }
      }
    }
  }

  .margin-bottom {
    margin-bottom: 0;
  }
  .lockout-box {
    display: flex;
    align-items: center;

    .svg-icon {
      margin-right: 5px;
    }
  }

  .is-lockout {
    color: #f44242;
  }

  .not-lockout {
    color: #0abf5b;
  }
}
::v-deep .employe-dialog {
  // .el-dialog__header {
  //   padding: 25px 25px 20px 25px;
  // }
  .el-dialog__body {
    padding: 0 25px;
  }
  // .el-dialog__footer {
  //   padding: 15px 25px 25px 25px;

  //   .upload-btn {
  //     margin-right: 10px;
  //   }
  // }
}
::v-deep .examine-dialog {
  .el-dialog__header {
    @include flex(row, center);
    padding: 25px 25px 20px 25px;
    .el-dialog__headerbtn {
      top: 27px;
    }
  }
  .el-dialog__body {
    padding: 0 25px;
    color: #666;
  }
  .el-dialog__footer {
    padding: 15px 25px 25px 25px;
  }
  .upload-btn {
    margin-right: 10px;
  }
  .el-textarea {
    width: 396px;
  }
  .no-margin-bototm {
    margin-bottom: 0;
  }
}
</style>

